import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';

@Injectable()
export class InstallationAniloxPluginService extends InspectionPluginService {
  private deliveredPriorKeys: any = [
    { value: 1, label: 'plugins.response.boolean.true' },
    { value: 2, label: 'plugins.response.boolean.false' }
  ];

  private deliveredPrior: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected factory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, factory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateAnilox(inspectionId: string, pointId: string, pluginId: string, anilox: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, anilox).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getDeliveredPrior() {
    return this.deliveredPrior;
  }

  public applyTranslations() {
    this.deliveredPrior = [];
    this.copyTranslationValues(this.deliveredPriorKeys, this.deliveredPrior, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, anilox: any[]): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, pointId, pluginId, anilox, 'Anilox').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
